<div class="footer-extended d-none">
    <div class="s7-container">
        <div class="row">
            <div class="col-lg-3 mb-3 mb-lg-0">
                <h4 class="footer-extended-title">{{ 'shared:footer.virtualManager' | i18next }}</h4>
                <div class="footer-extended-item">{{ 'shared:footer.siteTechSupport' | i18next }}</div>
                <div class="footer-extended-item">8 800 200 888 6</div>
                <div class="footer-extended-item">
                    <a href="mailto:vm@s7.ru" class="footer-extended-link">
                        <span class="link-dotted">vm@s7.ru</span>&nbsp;
                        <svg class="icon icon-arrow-right-circle">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="dist/icons.svg#arrow-right-circle"></use>
                        </svg>
                    </a>
                </div>
                <div class="footer-extended-item">
                    <a href="mailto:agency@s7.ru" class="footer-extended-link">
                        <span class="link-dotted">agency@s7.ru</span>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 mb-3 mb-lg-0">
                <h4 class="footer-extended-title">{{ 'shared:footer.s7TravelExpert' | i18next }}</h4>
                <div class="footer-extended-item">{{ 'shared:footer.cashierBonusOffer' | i18next }}</div>
                <div class="footer-extended-item">
                    <a href="mailto:kassir.bonus@s7.ru" class="footer-extended-link">
                        <span class="link-dotted">kassir.bonus@s7.ru</span>&nbsp;
                        <svg class="icon icon-arrow-right-circle">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="dist/icons.svg#arrow-right-circle"></use>
                        </svg>
                    </a>
                </div>
                <div class="footer-extended-item">
                    <a href="https://bonus.s7.ru" class="footer-extended-link">
                        <span class="link-dotted">bonus.s7.ru</span>
                    </a>
                </div>
            </div>
            <div class="col-lg-3 mb-3 mb-lg-0">
                <h4 class="footer-extended-title">{{ 'shared:footer.technologies' | i18next }}</h4>
                <div class="footer-extended-item">{{ 'shared:footer.legislativeAndNormativeDocuments' | i18next }}</div>
                <div class="footer-extended-item">
                    <a href="https://partner.s7.ru" class="footer-extended-link">
                        <span class="link-dotted">partner.s7.ru</span>&nbsp;
                        <svg class="icon icon-arrow-right-circle">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="dist/icons.svg#arrow-right-circle"></use>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="s7-page-footer">
    <div class="s7-page-footer-wrapper">
        <div class="s7-page-footer-label">
            {{ 'shared:footer.footerMadeBy' | i18next }} <a href="https://trueengineering.ru/" target="_blank">True Engineering</a>
        </div>
        <div class="flex-grow-1"></div>
        <div class="s7-page-footer-label">
            &copy; {{ thisYear }} <a href="https://www.s7.ru/" target="_blank">S7 Airlines</a>
        </div>
    </div>
</footer>
